// CAMPAIGN CONSTANTS — va-benefit-to-keys
// [[NEEDS CONFIRMATION]] markers are intentional and must remain until compliance/event details clear.

export const PREVIEW_MODE = true; // flip to false only after compliance clears go-live

export const CAMPAIGN = {
  hostName: "Chaunci Witherspoon, MBA",
  hostCompany: "Kinsfolk Mortgage",
  hostLegalCompany: "Kinsfolk Mortgage LLC",
  hostNmls: "1703351",
  companyNmls: "2610890",
  licensedIn: "Florida",
  hostInitials: "CW",
  headshot: "/assets/chaunci-witherspoon-headshot.png",
  logo: "/assets/kinsfolk-mortgage-logo.png",
  equalHousingLogo: "/assets/equal-housing-lender.png",
  email: "c.witherspoon@kinsfolkmortgage.com",
  phone: "(813) 710-4602",
  website: "https://kinsfolkmortgage.com/",
  webinarTitle: "BENEFIT TO KEYS",
  webinarDate: "September 24, 2026",
  webinarTime: "8:00 PM",
  webinarTimezone: "ET",
  webinarDuration:
    "[[WEBINAR DURATION — NEEDS CONFIRMATION; suggested display is 60 minutes including live Q&A]]",
  offerType: "va-benefit-to-keys",
};

// [[COMPLIANCE TO REVIEW — TCPA CONSENT COPY]]
export const CONSENT_TEXT =
  "By checking this box, I agree to receive recurring informational and marketing calls and text messages from Kinsfolk Mortgage and Chaunci Witherspoon, MBA at the number provided, including through automated technology. Consent is not a condition of purchase. Message and data rates may apply. Frequency varies. Reply STOP to opt out and HELP for help. View the Privacy Policy and Terms.";

export const QUESTION_OPTIONS = [
  "I have not verified eligibility/entitlement",
  "I have verified eligibility but have not used it",
  "I used VA financing before",
  "I am comparing VA with another financing path",
  "I am not sure where to start",
];

export const BONUSES = [
  "Live Florida Benefit-to-Keys Workshop",
  "VA Benefit-to-Keys Workbook",
  "Buying-Power Input Planner",
  "Cash-to-Close Category Guide",
  "Optional Complimentary VA Homebuying Strategy Session",
];

// [[COMPLIANCE TO REVIEW — FINAL DISCLOSURE WORDING]]
export const COMPLIANCE_DISCLOSURE =
  "This is an educational webinar and is not a commitment to lend. Attendance does not constitute a loan application. No hard credit pull is required to attend. All loans are subject to application, borrower and property eligibility, credit review, documentation, program guidelines, and underwriting approval. Interest rates, loan terms, payments, costs, and program availability may change and vary by borrower and transaction. Results are not guaranteed. VA home loan eligibility requires qualifying service or other qualifying status and is subject to verification. VA financing is not offered by the Department of Veterans Affairs itself, and this event is not sponsored by, endorsed by, or affiliated with the U.S. Department of Veterans Affairs or any government agency. Chaunci Witherspoon, MBA, NMLS #1703351; Kinsfolk Mortgage LLC, Company NMLS #2610890; licensed in Florida. Equal Housing Opportunity. Final wording is subject to Kinsfolk Mortgage compliance approval.";

export const COPYRIGHT_LINE =
  "© 2026 Kinsfolk Mortgage · Chaunci Witherspoon, MBA · NMLS #1703351";
